<template>
  <div>
    <v-card outlined tile elevation="0" class="rounded-lg ma-4">
      <v-sheet :class="showCard ? '' : 'rounded-lg'" color="primary">
        <v-card-title class="pa-2 card-title-height">
          <v-btn icon elevation="0" class="" @click="showCard = !showCard">
            <v-icon color="white">
              {{
                showCard ? "mdi-chevron-up" : "mdi-chevron-down"
              }}
            </v-icon>
          </v-btn>
          <div class="text-body-1 ml-2 white--text">Préférences de contact</div>
          <v-spacer />
        </v-card-title>
      </v-sheet>
      <v-expand-transition>
        <div v-if="loading">
          <v-progress-linear indeterminate color="primary" />
          <v-skeleton-loader class="mb-4" type="list-item-three-line" />
        </div>
        <div v-else v-show="showCard">
          <v-card-text class="grey lighten-4">
            <div>
              <span
                v-if="!content.iresa_confiance"
                class="subtitle-1"
              >
                Les communications ne seront envoyées que si la confiance est active
              </span>
              <div class="d-flex justify-space-between">
                <span class="h4 font-weight-bold">
                  Préférences de contact Vacances
                </span>
                <span class="text-caption grey--text" v-if="newsletters.ucpa_last_update_time">Date de dernière modification: {{ newsletters.ucpa_last_update_time }}</span>
              </div>
              <v-switch
                v-model="newsletters.ucpa_newsletter"
                class="mt-2"
                dense
                :label="labels['ucpa_newsletter']"
              />
            </div>
            <div class="mt-4">
              <div class="d-flex justify-space-between">
                <span class="h4 font-weight-bold">
                  Préférences de contact Loisirs
                </span>
                <span class="text-caption grey--text" v-if="newsletters.loisirs_last_update_time">Date de dernière modification: {{ newsletters.loisirs_last_update_time }}</span>
              </div>
              <v-switch
                v-model="newsletters.loisirs_newsletter"
                class="mt-2"
                dense
                :label="labels['loisirs_newsletter']"
              />
            </div>
          </v-card-text>
          <div v-if="isEditingContactPreferences">
            <v-divider />
            <v-card-text class="d-flex justify-end">
              <v-btn :disabled="loading" color="secondary" elevation="0" class="mx-2 px-4" @click="saveNewsletters()">
                <v-icon class="mr-3">mdi-content-save</v-icon>
                Enregistrer
              </v-btn>
            </v-card-text>
          </div>
        </div>
      </v-expand-transition>
    </v-card>
  </div>
</template>

<script>

const _ = require('lodash');

export default {
  name: 'ContactPreferencesCard',
  components: { },
  props: {
    content: {
      type: Object,
      default: null
    },
    saveCustomer: {
      type: Function,
      required: true
    }
  },
  data () {
    return {
      loading: false,
      showCard: true,
      newsletters: { ...this.content.newsletters },
      labels: {
        ucpa_newsletter: 'Accepte de recevoir des communications de la part de l’UCPA vacances',
        loisirs_newsletter: 'Accepte de recevoir des communications de la part de l’UCPA loisirs'
      }
    };
  },
  computed: {
    allSelected: {
      get: function () {
        const { loisirs_newsletter, ...newsletters } = this.newsletters;
        return Object.values(newsletters).every(
          n => n === true
        );
      },
      set: function (newValue) {
        for (const [key, value] of Object.entries(this.newsletters)) {
          if (!['ucpa_newsletter', 'loisirs_newsletter'].includes(key)) {
            this.newsletters[key] = newValue;
          }
        }
      }
    },
    isEditingContactPreferences () {
      return !this.compareNewsletters(this.newsletters, this.content.newsletters);
    }
  },
  methods: {
    async saveNewsletters () {
      this.loading = true;
      const editableContent = { ...this.content };
      editableContent.newsletters = this.newsletters;

      await this.saveCustomer(editableContent);

      this.newsletters = { ...this.content.newsletters };

      this.loading = false;
    },
    compareNewsletters (newslettersA, newslettersB) {
      return !newslettersA.ucpa_newsletter === !newslettersB.ucpa_newsletter
        && !newslettersA.loisirs_newsletter === !newslettersB.loisirs_newsletter;
    }
  }
};

</script>
